import React from 'react';
import { styleMapping } from "./utils/tools";
import NavBar from './core/navbar';
import Sidebar from "react-sidebar";
import SideMenu from './core/sideMenu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as actions from '../store/pseudo/general';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

class CustomLayout extends React.Component {

    // ##################################  CONSTRUCTOR  ####################################
    // ##################################  CONSTRUCTOR  ####################################
    constructor(props) {
        super(props);
        this.state = { infoModal: null };
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.location &&
            this.props.location &&
            prevProps.location.pathname !== this.props.location.pathname &&
            this.props.sideMenu
        ) {
            this.closeMenu();
        }
    }

    handleMenuToggle = () => {
        this.props.sideMenuFunction(!this.props.sideMenu);
    }

    handleMenuState = (isOpen) => {
        if (isOpen !== this.props.sideMenu) {
            this.props.sideMenuFunction(isOpen);
        }
    }

    closeMenu = () => {
        if (this.props.sideMenu) {
            this.props.sideMenuFunction(false);
        }
    }
    
    render() {        
        if(this.props.settings){
            const {structure, logo} = this.props.settings;

            return (
            <div id="container" className={"layout " + structure.container.class} style={styleMapping(structure.container)}>
                <NavBar></NavBar>
                    <div className={"MobileMenu Fixed Bottom10px Left20px z2000"}>
                        <button
                            type="button"
                            className="burger-menu-trigger"
                            aria-label={this.props.sideMenu ? "Close menu" : "Open menu"}
                            aria-expanded={this.props.sideMenu}
                            onClick={this.handleMenuToggle}
                        >
                            <FontAwesomeIcon icon={"bars"} color={logo.title.color} />
                        </button>
                    </div>
                <Sidebar 
                    settings={this.props.settings} 
                    sidebar={<SideMenu onClose={this.closeMenu} />} 
                    dragToggleDistance={15} 
                    onSetOpen={(isOpen)=>{ this.handleMenuState(isOpen)}} 
                    open={this.props.sideMenu} 
                    styles={{
                        sidebar: {
                            position: 'fixed',
                            height:'100vh',
                            minWidth: 280,
                            width:'min(86vw, 360px)',
                            background: "white",
                            zIndex: 3001,
                            padding: '0'
                        },
                        overlay: {
                            zIndex: 3000,
                            backgroundColor: 'rgba(20, 10, 12, 0.36)',
                            backdropFilter: 'blur(1px)'
                        }
                    }}>
                    <div />
                </Sidebar>

               <div className="BRL Wide100" style={{minHeight:'70vh'}}>
                    {
                        this.props.children
                    }
                </div>
            </div>
            );
        } else return null; 
    }
}


const mapstateToProps = (state) => {
    return {
        isAuthenticated: state.status.token !== null && state.status.token !== '' ? true : false, 
        status:state.status, 
        sideMenu:state.sideMenu, 
        user:state.user, 
        architecture:state.architecture, 
        settings:state.settings,
        direction: state.current.direction
    };
}
const mapDispatchToProps = dispatch => {
    return {
        navigate: (direction, history) => dispatch(actions.navigate(direction, history)), 
        sideMenuFunction: (bVal) => dispatch(actions.sideMenu(bVal))
    }
}
export default withRouter(connect(mapstateToProps, mapDispatchToProps)(CustomLayout));

